var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 5H28.0067C32.145 5 35.5 8.355 35.5 12.4933V27.5083C35.5 31.645 32.145 35 28.0067 35H12.9933C8.855 35 5.5 31.645 5.5 27.5067V12.5C5.5 8.35833 8.85833 5 13 5V5Z",
    stroke: "#00B26B",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.585 23.9099C20.2234 27.5499 24.8334 29.8699 27.575 27.1399L28.24 26.4749C29.1267 25.5899 29.0034 24.1233 27.9734 23.4083C27.325 22.9566 26.6284 22.4716 25.8584 21.9299C25.0617 21.3699 23.97 21.4583 23.2784 22.1433L22.5267 22.8899C21.595 22.2999 20.6734 21.5416 19.8167 20.6866L19.8134 20.6833C18.9584 19.8283 18.2 18.9049 17.61 17.9733L18.3567 17.2216C19.0434 16.5316 19.1284 15.4383 18.57 14.6416C18.0267 13.8716 17.5417 13.1749 17.0917 12.5266C16.3767 11.4983 14.91 11.3749 14.025 12.2599L13.36 12.9249C10.6317 15.6666 12.95 20.2733 16.5884 23.9149",
    stroke: "#00B26B",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.5577fb8859c41b08a4573ba6dd60eefa.svg";
export { ForwardRef as ReactComponent };